import {checkIfIncomingActionAllowed} from "../../redux/relayedActions";
import {selectHexes, selectPolicyMarket, selectUnits} from "../../redux/reducers/sharedStateReducer/selectors";
import {selectConstructionPlanEntries} from "../../redux/reducers/privateStateReducer/selectors";
import {playEffectForServerAction} from "../../scenes/playEffectForServerAction";

/**
 * Применение экшена, пришедшего по сокету матча: последняя ветка разбора
 * сообщений в LobbyPage, вынесенная отдельно ради фильтра.
 *
 * Сообщение здесь уходит прямо в общий redux-стор, поэтому принимается только
 * то, что пропустил бы и сервер (см. redux/relayedActions): игровое действие
 * матча либо экшен, который сервер разослал сам (с серверной меткой). Иначе
 * игрок со своим вебсокет-клиентом продиспатчил бы соседям по лобби экшен
 * любого типа.
 *
 * Отбрасываются здесь и служебные типы протокола лобби (DELEGATE_BOT_WORK,
 * RANK_MATCH_*) — их разбирают подписчики трафика, а редьюсерам они и раньше
 * были не нужны. Реакции (REACTION_RECEIVED) нужны редьюсеру очереди тостов —
 * сервер рассылает их с серверной меткой.
 *
 * Возвращает true, если экшен применен.
 */
export const applyRelayedServerAction = (msg, store, dispatch) => {
  if (!checkIfIncomingActionAllowed(msg)) {
    return false;
  }

  // Рынок политик, поле и план строительства ДО применения экшена — эффекты
  // покупки политики, роста города и дохода гильдий/храмов сравнивают
  // состояние до и после (см. playEffectForServerAction). План — отдельно:
  // экшен может снять его часть прямо внутри dispatch (constructionPlanMiddleware).
  // Отряды — ради исходной ячейки перемещения: в самом экшене ее нет
  const state = store.getState();
  const policyMarket = selectPolicyMarket(state);
  const prevHexes = selectHexes(state);
  const prevPlanEntries = selectConstructionPlanEntries(state);
  const prevUnits = selectUnits(state);

  dispatch({...msg, _fromServer: true});

  // Состояние до экшена целиком — по нему способности фракций придерживают
  // свой итог на поле до конца анимации
  playEffectForServerAction(msg, policyMarket, prevHexes, prevPlanEntries, prevUnits, state);
  return true;
};
